import { render, staticRenderFns } from "./PlaceModal.vue?vue&type=template&id=6b9bbde6&"
import script from "./PlaceModal.vue?vue&type=script&lang=js&"
export * from "./PlaceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports